<template>
    <InformeCard
        id="desglose-metodos-pago"
        name="desglose-metodos-pago"
        collapsable="true"
        title="Desglose por métodos de pago"
    >
        <ContentOrLoading>
            <div v-if="desglose_metodos_pago" class="row table table-responsive width-responsive">
                <div class="col-12 pr-0">
                    <table class="table table-hover text-nowrap">
                        <thead>
                            <tr>
                                <th>Método de pago</th>
                                <th>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(metodo_pago, index) in desglose_metodos_pago">
                                <tr :key="index">
                                    <td>{{ metodo_pago.metodo_pago }}</td>
                                    <td>{{ metodo_pago.importe_total | formatear_precio }}</td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </ContentOrLoading>
    </InformeCard>
</template>

<script>
    import InformeCard from "../InformeCard";

    export default {
        props: ['lista_id', 'fecha_inicio', 'fecha_fin'],
        data() {
            return {
                loading: false,
                desglose_metodos_pago: null
            }
        },
        methods: {
            getDesgloseMetodosPago() {
                this.loading = true;

                const params = {
                    filters : {},
                    lista_id: this.lista_id
                };

                if (this.fecha_inicio && this.fecha_fin) {
                    params.filters.fecha_inicio = this.fecha_inicio;
                    params.filters.fecha_fin = this.fecha_fin;
                
                }

                this.$store.dispatch(this.config.getVuexAlias('back.abonos.informe.metodos-pago'), params).then(res => {
                    this.desglose_metodos_pago = res.data.data;
                }).finally(() => this.loading = false);
            },
        },
        created() {
            this.getDesgloseMetodosPago();
        },
        components: {
            InformeCard
        }
    }
</script>

<style scoped>
     @media (max-width: 700px) {
        .width-responsive {
            width: 295px;
        }
     }
</style>